import { Dialog } from "primereact/dialog";
import TaskCommentSuccessView from "../../TaskCommentSuccessView";
import FileCheckIcon from "../../../../../assets/file-check.svg";
import PropTypes from "prop-types";

interface SuccessModalProps {
  visible: boolean;
  closeSuccessModal: () => void;
  onNavigate: () => void;
}

const SuccessModal = ({
  visible,
  closeSuccessModal,
  onNavigate,
}: SuccessModalProps) => {
  return (
    <Dialog
      onHide={closeSuccessModal}
      style={{ width: "50vw" }}
      visible={visible}
    >
      <TaskCommentSuccessView
        Header="Files Are Being Processed"
        Description="We're now processing your files. You'll be notified as soon as everything is ready."
        Icon={<img src={FileCheckIcon} alt="File Check" />}
        onCancel={closeSuccessModal}
        onNavigate={onNavigate}
      />
    </Dialog>
  );
};

SuccessModal.propTypes = {
  visible: PropTypes.bool,
  closeSuccessModal: PropTypes.func,
};

export default SuccessModal;
